import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CreateAdhocInvoiceByCsvButton from "./components/CreateAdhocInvoiceByCsvButton";
import UnapprovedInvoiceTable from "./components/UnapprovedInvoiceTable";
import HeaderContent from "../../components/layout/components/HeaderContent";
import ExportCommercialDocumentButton from "../commercialDocuments/components/ExportCommercialDocumentButton";
import { availableOnlySuperAdmin } from "utils/validation";

const UnapprovedInvoiceList = () => {
  const breadcrumb = [
    { link: "/unapprovedInvoices", title: "Unapproved Invoices" },
  ];

  return (
    <>
      <HeaderContent
        breadcrumb={breadcrumb}
        headerTitle="Unapproved Invoices"
        isNotHaveSchoolFilter
      />
      <SanitizedGrid container spacing={2}>
        <Grid item xs={6}>
          <Typography variant="h6">Unapproved Invoices</Typography>
        </Grid>
        <Grid item xs={6}>
          <CreateAdhocInvoiceByCsvButton />
          {availableOnlySuperAdmin() && (
            <ExportCommercialDocumentButton documentType="Invoice" />
          )}
        </Grid>

        <Grid item xs={12}>
          <UnapprovedInvoiceTable />
        </Grid>
      </SanitizedGrid>
    </>
  );
};

export default UnapprovedInvoiceList;
